/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// match css value between "font-family:" and ";"
const parseFont = (font) => font?.match(/:\s(.*?);/, '')?.[1] || null;
export default parseFont;
